//import { CSRF } from "@rails/request.js";

// refresh CSRF tokens
function showColumnSortSpinner(column) {
  $('th.col-' + column).find(".ajax-indicator").css('display', 'inline-block');
  $('th.col-' + column).find(".sort-icon").hide();
}

var refreshCSRFTokens = function() {

  console.log("refreshCSRF");
  const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  document.querySelectorAll('form input[name="authenticity_token"]').forEach((el) => {
    el.value = token;
  });
}

window.refreshCSRFTokens = refreshCSRFTokens;

$(function(){

  // fix bootstrap_form_for text fields
  $(document).on('change', '.custom-file-input', function(e){
    var fileLabel = $(e.target).closest('.custom-file').find('.custom-file-label');
    fileLabel.text(e.target.value.replace(/^.*[\\\/]/, '')); 
  });

  $(document).on('click', '.btn-toggle-dfc', function(e){
    console.log(e.target);
    if ($(e.target).closest("[data-toggle=button]").hasClass("active")) {
      $(e.target).closest(".price-card-dfc").addClass("active");
    } else {
      $(e.target).closest(".price-card-dfc").removeClass("active");
    }
    
  });

  
  $(".btn-show-jwt").click(function() {
    $("#jwt").attr("type", "text");
  });

  $(document).on('click', '.btn-copy-to-clipboard', function (e) {
    var target = $(this).closest(".copy-to-clipboard-scope").find($(this).data("target"));

    if (target.attr("type") == "password") {
      target.attr("type", "text");
    }

    target.select();
    document.execCommand("copy");

    if ($(this).data("message-container")) {
      var messageContainer = $(this).closest(".copy-to-clipboard-scope").find($(this).data("message-container"));
      messageContainer.html("<div class='alert alert-info'>" + $(this).data("message") + "</div>");
    }
  });

  $(document).ajaxComplete(function() {
    refreshCSRFTokens();

  });
  $(".layout-auth-identity-form").on('submit', function(){
     //lower case auth key (email addresses) for all user validation
      $(this).find('.layout-auth-identity-form-email').val($(this).find('.layout-auth-identity-form-email').val().toLowerCase());
     
  });
  $("#layout-scoops-sidebar-pop-close").click(function(){
    // set cookie
    Cookies.set('layout-sidebar-pop-disable', 'true', { expires: 3650, path: '/' });
    $('#layout-scoops-sidebar-pop').hide();
  });

  var popDisable = Cookies.get('layout-sidebar-pop-disable');
  if (popDisable === undefined) {
    $("#layout-scoops-sidebar-pop").removeClass("hidden");
  }
  $(document).on('click', '.search-trigger', function(event){
    event.preventDefault();
    // close any menus that are open
    $('.cd-morph-dropdown').removeClass("nav-open");
    $('.layout-search-form').toggleClass('active');
    $('.layout-search-input-field').focus();
  });

  $("#layout-show-submenu").each(function() {
    var target = "#layout-submenu-" + $(this).data("target");
    $(target).addClass("show");
    $(".cd-main-content").addClass("cd-main-content-with-submenu");
  });

	/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
	var prevScrollpos = window.pageYOffset;
	window.onscroll = function() {
		var currentScrollPos = window.pageYOffset;
		if (prevScrollpos > currentScrollPos) {
      if ($(window).scrollTop() == 0) {
        $("#main-navigation").removeClass("nav-hidden");
        $("#main-navigation").removeClass("nav-fixed");
      } else {
        //document.getElementById("main-navigation").style.top = "0";
        $("#main-navigation").addClass("nav-fixed");
        $("#main-navigation").removeClass("nav-hidden");
      }
		} else if ($(window).scrollTop() > 122) {
			//document.getElementById("main-navigation").style.top = "-200px";
      $("#main-navigation").addClass("nav-hidden");
      $("#main-navigation").removeClass("nav-fixed");
		}
		prevScrollpos = currentScrollPos;
	}

});


function popout(url) {
  window.open(url, "_blank", "toolbar=no,menubar=no,status=no,resizeable=no,location=no");
};
